// The backend's folder name limit.
export const FOLDER_NAME_MAX_LENGTH = 100;

// The backend's plan limit for one suggestion, and the error code it answers with above it.
export const SUGGESTION_PLANS_MAX = 400;
export const TOO_MANY_PLANS_ERROR_CODE = "tooManyPlans";

// The import's error code when a listed plan no longer exists.
export const UNKNOWN_FLOOR_PLANS_ERROR_CODE = "unknownFloorPlans";

// Dropdown value for "leave the plan where it is"; folder options use their draft key.
export const UNSORTED_FOLDER_OPTION = "";

// Joins building and level in a "By building and level" folder name.
export const COMBINED_FOLDER_NAME_SEPARATOR = " · ";
